import { render, staticRenderFns } from "./GlossaryBadObjects.vue?vue&type=template&id=0431c6de&scoped=true&"
import script from "./GlossaryBadObjects.vue?vue&type=script&lang=js&"
export * from "./GlossaryBadObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431c6de",
  null
  
)

export default component.exports